import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DisplayService {

  constructor() { }

  displayReportNames(uniqueNumber: string) {
    let prefix = uniqueNumber.substring(0,2);
    let newName = '';

    if (prefix === 'FL') {
      newName = 'Flash';
    } else if (prefix === 'RR') {
      newName = 'Report';
    } else if (prefix === 'B5' || prefix === 'DB') {
      newName = 'Update';
    } else if (prefix === 'CT') {
      newName = 'Table';
    } else {
      newName = 'Cullen report'
    }
    // switch(prefix) {
    //   case 'FL': {
    //     newName = 'flash';
    //     break;
    //   }
    //   default: {
    //     newName = 'Cullen report'
    //     break;
    //   }
    // }
    return newName;
  }

  hideCellOnMobile(price: any): boolean {
    return price === '/';
    // if (price === '/') {
    //   return true;
    // }
    // return false;
  }
}
